var exports = {
  "k": "x04b3a21e--e23a64--container",
};

module.exports = exports;
